<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <ng-template [ngTemplateOutlet]="templateHeaderInfo"></ng-template>
        </div>
        <div class="flex-fill"></div>
        <ng-template
          [ngTemplateOutlet]="actions"
          [ngTemplateOutletContext]="{ preview: currentTab == tabs.Fields }"
        ></ng-template>

        <ng-container [ngSwitch]="currentTab">
          <button class="btn btn-secondary-info" (click)="onSaveSigners(addSignersForm)" *ngSwitchCase="tabs.Signers">
            <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
          </button>
          <button class="btn btn-secondary-info" (click)="onSaveFields(fieldsForm)" *ngSwitchCase="tabs.Fields">
            <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
          </button>
          <button
            class="btn btn-secondary-info"
            (click)="onSaveDetails(templateDetailsForm)"
            *ngSwitchCase="tabs.Details"
          >
            <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
          </button>
        </ng-container>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav drawer-right-navbar">
      <li [class.active]="currentTab === tabs.Signers" i18n-matTooltip matTooltip="Signers" matTooltipPosition="left">
        <a (click)="currentTab = tabs.Signers">
          <i class="cs-icon cs-icon-user-plus"></i>
        </a>
      </li>
      <li
        [class.active]="currentTab === tabs.Fields"
        i18n-matTooltip
        matTooltip="Place Fields"
        matTooltipPosition="left"
      >
        <a (click)="currentTab = tabs.Fields">
          <i class="cs-icon cs-icon-field text-xl"></i>
        </a>
      </li>
      <li
        [class.active]="currentTab === tabs.Details"
        i18n-matTooltip
        matTooltip="Template Details"
        matTooltipPosition="left"
      >
        <a (click)="currentTab = tabs.Details">
          <i class="cs-icon cs-icon-file-alt2"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body" [class.p-0]="currentTab === tabs.Fields">
      <ng-container [ngSwitch]="currentTab">
        <div *ngSwitchCase="tabs.Signers">
          <div class="alert alert-warning" *ngIf="!isRolesEditable" i18n>
            You cannot edit roles of the template with automations associated.
          </div>
          <app-add-roles-form
            [form]="addSignersForm"
            [templateType]="templateType"
            [isRolesEditable]="isRolesEditable"
          ></app-add-roles-form>
        </div>

        <ng-container *ngSwitchCase="tabs.Fields">
          <app-place-fields-form
            class="h-100"
            #placeFieldsFormCom
            [form]="fieldsForm"
            [templateType]="templateType"
            [templateFileUrl]="templateFileUrl"
            [roles]="roles"
          ></app-place-fields-form>
        </ng-container>

        <div *ngSwitchCase="tabs.Details" class="container-box p-3">
          <app-template-details-form [form]="templateDetailsForm"></app-template-details-form>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #templateHeaderInfo>
  <div class="">
    <h6 class="modal-title" i18n>Edit Template</h6>
    <ul class="dot-segments-list text-muted">
      <li>{{ template?.name }}</li>
      <li>{{ template?.updated | epoch }}</li>
      <li>{{ template?.updated | epoch : 'hh:mm A' }}</li>
    </ul>
  </div>
</ng-template>

<ng-template #actions let-preview="preview">
  <div dropdown class="dropdown">
    <button dropdownToggle class="btn btn-secondary-warning">
      <i class="cs-icon cs-icon-bolt"></i> <ng-container i18n>Actions</ng-container>
    </button>

    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
      <li *ngIf="preview">
        <a href="javascript:;" class="dropdown-item" (click)="onPreview()">
          <i class="far fa-eye fa-fw" aria-hidden="true"></i>
          <ng-container i18n>Preview</ng-container>
        </a>
      </li>
      <li>
        <a
          i18n-matTooltip
          matTooltip="Send this template to a guest, an account user, or a one-off signer of your own choosing."
          matTooltipPosition="left"
          *ngIf="isReadyToUse()"
          (click)="onSend()"
        >
          <i class="far fa-paper-plane fa-fw" aria-hidden="true"></i>
          <ng-container i18n>Send</ng-container>
        </a>
      </li>
      <li>
        <a i18n-matTooltip matTooltip="Edit the name of this template." matTooltipPosition="left" (click)="onRename()">
          <i class="far fa-edit fa-fw" aria-hidden="true"></i> <ng-container i18n>Rename</ng-container>
        </a>
      </li>
      <li>
        <a
          i18n-matTooltip
          matTooltip="Download this template as a PDF."
          matTooltipPosition="left"
          (click)="onDownload()"
        >
          <i class="far fa-cloud-download fa-fw" aria-hidden="true"></i>
          <ng-container i18n>Download</ng-container>
        </a>
      </li>
    </ul>
  </div>
</ng-template>
